const _excluded = ["stylers"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import { assign, reduce } from 'lodash';
export default function getStaticMapScheme(scheme) {
  const staticScheme = scheme.reduce((styleParams, _ref) => {
    let {
        stylers = []
      } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);
    const flatScheme = assign({}, rest, ...stylers);
    const styleStrings = reduce(flatScheme, (styleString, val, key) => {
      // eslint-disable-line arrow-body-style
      styleString.push("".concat(key.replace(/type/gi, ''), ":").concat(val.replace(/#/g, '0x')));
      return styleString;
    }, []);
    styleParams.push("style=".concat(styleStrings.join('|')));
    return styleParams;
  }, []);
  return encodeURI(staticScheme.join('&'));
}
;
//# sourceMappingURL=getStaticMapScheme.js.map